import type { SelectOption } from '~/shared/utils/types';

import type { ExplorationVolume } from '../../types/exploration';
import { buildInstanceIdOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function InstanceIdFilter({
  volumes,
  pendingInstanceFilters,
  setPendingInstanceFilters,
  globalSearchQuery = '',
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingInstanceFilters: SelectOption[];
  setPendingInstanceFilters: (filters: SelectOption[]) => void;
  globalSearchQuery?: string;
  isDisclosureOpen?: boolean;
}) {
  const options = buildInstanceIdOptions(volumes);

  const handleChange = (instanceId: string) => {
    const selected = pendingInstanceFilters.some((f) => f.id === instanceId);
    if (selected) {
      setPendingInstanceFilters(pendingInstanceFilters.filter((f) => f.id !== instanceId));
    } else {
      setPendingInstanceFilters([
        ...pendingInstanceFilters,
        { id: instanceId, name: instanceId, group: 'instanceId' },
      ]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      globalSearchQuery={globalSearchQuery}
      showSectionSearch
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingInstanceFilters.some((f) => f.id === key)}
      onToggle={handleChange}
      tagVariant="instance"
    />
  );
}

export function buildInstanceIdFilterOptions(volumes: ExplorationVolume[]) {
  return buildInstanceIdOptions(volumes);
}
